class BubbleBorder extends HTMLElement {
  connectedCallback() {
    this.svg = this.querySelector('svg');
    if(!this.svg) {
      return;
    }
    this.bubbleWrapper = this.querySelector('.bubble-wrapper');
    this.svgWidth = this.svg.clientWidth;
    this.setupBorder();
    window.addEventListener('resize', debounce(this.setupBorder.bind(this), 300));
  }

  setupBorder() {
    this.bubbleWrapper.replaceChildren();
    this.bubbleWrapper.append(this.svg);
    const svgWidth = this.svg.clientWidth;
    const pageWidth = window.innerWidth;
    const circlesRequired = Math.floor(pageWidth / svgWidth);
    for(let i = 0; i < circlesRequired; i++) {
      this.bubbleWrapper.append(this.svg.cloneNode(true))
    }
  }
}

customElements.define('bubble-border', BubbleBorder);